var _circle, _circle2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasculine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#D9DBE3",
    stroke: "#D9DBE3",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2575_11659",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 46,
    height: 46
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2575_11659)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91167 31.0865C7.08358 31.5632 7.21598 32.0532 7.30753 32.5516C7.48719 33.8449 7.51062 35.1551 7.3773 36.454L6.1958 33.4282L6.91167 31.0865Z",
    fill: "#DE7C62"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1708 35.5002L38.5772 49.3505H38.5484C38.233 50.6114 37.4674 51.7135 36.3959 52.4491C35.3244 53.1847 34.0209 53.5032 32.7308 53.3445C31.4408 53.1859 30.2533 52.561 29.392 51.5877C28.5307 50.6143 28.055 49.3596 28.0545 48.0598C28.0548 47.6878 28.0934 47.3168 28.1698 46.9527L29.8639 39.477C28.9592 38.6853 28.2777 37.6705 27.8873 36.5335C27.4968 35.3965 27.411 34.1771 27.6384 32.9967C27.8658 31.8162 28.3986 30.716 29.1835 29.8055C29.9684 28.8949 30.9782 28.2059 32.1123 27.8071C33.2463 27.4082 34.4651 27.3134 35.6471 27.5321C36.8292 27.7508 37.9334 28.2754 38.8497 29.0536C39.766 29.8317 40.4624 30.8364 40.8697 31.9675C41.2769 33.0985 41.3807 34.3166 41.1708 35.5002Z",
    fill: "#FAAA5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6967 62.074L42.8195 59.8808L38.6699 47.9431L28.1699 46.9466L33.6967 62.074Z",
    fill: "#FAAA5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3866 42.7302C34.4398 42.7305 35.4692 43.0431 36.3447 43.6284C37.2202 44.2137 37.9025 45.0455 38.3053 46.0185C38.7081 46.9916 38.8133 48.0622 38.6077 49.0951C38.402 50.1279 37.8948 51.0766 37.15 51.8212C36.4052 52.5658 35.4563 53.0728 34.4234 53.2781C33.3905 53.4835 32.3199 53.3779 31.347 52.9749C30.374 52.5718 29.5424 51.8892 28.9574 51.0136C28.3723 50.1379 28.0601 49.1084 28.0601 48.0553C28.0601 47.3559 28.1978 46.6633 28.4656 46.0171C28.7333 45.371 29.1256 44.7839 29.6203 44.2894C30.1149 43.7949 30.7021 43.4027 31.3484 43.1351C31.9946 42.8676 32.6872 42.73 33.3866 42.7302Z",
    fill: "#D8D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6164 39.9607C38.7029 45.7438 39.7539 51.768 38.8045 55.8858C38.7347 58.1305 38.8378 58.8615 38.8378 58.8615C38.8378 58.8615 34.6366 57.1765 24.1154 57.3691C17.2373 57.4965 12.4643 58.5825 12.0457 59.1391C12.0457 59.1391 12.0138 56.036 12.0457 55.1229C11.2661 46.1139 11.4299 47.3226 9.89656 40.7145C8.48769 39.9992 7.35678 38.8356 6.68197 37.407C6.00715 35.9783 5.82678 34.3657 6.16926 32.8232C6.51174 31.2808 7.35761 29.8961 8.57364 28.8872C9.78967 27.8784 11.3068 27.3027 12.8859 27.2509C12.8859 27.2509 30.9344 27.3434 35.128 27.348C36.844 27.5707 38.4204 28.41 39.5631 29.7093C40.7059 31.0087 41.337 32.6793 41.3388 34.4096C41.3388 36.6058 40.1831 38.6563 38.6194 39.9607",
    fill: "#FAAA5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4888 33.1995C26.4888 33.1995 26.9817 36.336 27.4276 41.7551C28.0039 48.7667 28.8851 57.1979 28.8851 57.1979",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8465 23.335C27.5947 23.881 29.6089 25.4705 29.345 26.8856C29.0811 28.3007 26.6408 29.0089 23.8941 28.4599C21.1473 27.9109 19.1317 26.3244 19.3941 24.9094C19.6564 23.4943 22.0983 22.786 24.8541 23.335",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8671 28.9592C28.8808 29.3914 28.0724 29.6841 26.8469 29.7691L26.5238 32.7615L25.353 29.7736C25.086 29.7605 24.8115 29.7392 24.5294 29.7099C22.1133 29.4551 20.131 28.7089 20.1159 28.0416C20.1143 27.9892 20.1252 27.9372 20.1477 27.8899L20.2509 18.2423L27.3004 18.3606L28.8413 28.7347H28.7882C28.8348 28.8014 28.8621 28.8795 28.8671 28.9607",
    fill: "#4676FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7056 31.4581L28.972 30.7408L26.4437 33.1113L22.4731 30.6376C22.4731 30.6376 21.7678 30.941 20.5211 31.4339C19.3654 30.4298 18.0322 28.9162 17.7607 27.4207C17.7607 27.4207 18.7269 24.1933 20.1874 23.7034C20.1874 23.7428 20.1874 23.7822 20.1874 23.8232C19.4685 24.348 19.0803 26.3924 23.8275 28.2822C24.466 28.3641 25.1834 29.0072 25.5732 30.1417L26.465 32.8383L26.7076 30.0492C26.7139 29.751 26.7745 29.4565 26.8866 29.1801C27.0106 28.9356 27.1811 28.7177 27.3886 28.5385C27.3886 28.5385 28.7809 27.7711 28.9341 27.2296C29.0477 26.8785 29.0504 26.5009 28.9418 26.1481C28.8333 25.7953 28.6188 25.4846 28.3274 25.258C28.3123 25.1533 28.2744 24.9061 28.2592 24.803C28.6642 25.0077 29.3345 25.622 29.7531 26.6685C30.8406 28.5643 30.7071 31.4642 30.7071 31.4642",
    fill: "#FAAA5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5196 31.4299C19.3639 30.4259 18.0308 28.9122 17.7593 27.4168M30.0823 27.3591C30.8088 29.1943 30.7041 31.4542 30.7041 31.4542L30.0823 27.3591Z",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6533 27.4712C28.5683 27.4515 28.4804 27.4302 28.3894 27.406C22.0891 25.7513 22.4743 20.1957 22.4743 20.1957L27.7508 21.3923L28.6533 27.4712Z",
    fill: "#2047AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6162 39.9611C38.7027 45.7442 39.7537 51.7684 38.8043 55.8862C38.7345 58.1309 38.8376 58.8619 38.8376 58.8619",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6949 31.5947L26.6636 30.5603C26.6636 30.5603 26.6924 29.0027 27.1883 28.5068C27.8375 27.8576 29.2905 29.024 30.6949 31.5947Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.519 31.595L25.7592 30.685C25.7091 30.6517 25.3193 28.724 24.3699 28.2735C23.7465 27.9777 21.4063 29.8387 20.519 31.5996",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1904 23.8312C20.0518 23.9388 19.9399 24.0768 19.8634 24.2346C19.7868 24.3925 19.7477 24.5658 19.7491 24.7412C19.7491 26.1169 21.8724 27.949 24.4098 28.4131C24.6904 28.5193 25.6429 29.8009 26.4422 33.1148C26.6879 30.9793 26.5438 28.7559 27.7389 28.2615C27.9832 28.1697 28.2099 28.0369 28.4093 27.8686C28.7505 27.5562 28.9947 27.1512 28.9947 26.7599C28.9947 26.2898 28.7551 25.806 28.338 25.3555",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9248 23.2563C28.4968 23.6583 27.968 23.9371 27.3945 24.0632C26.8195 24.1924 26.2205 24.1657 25.6594 23.9858C24.0805 23.4762 21.8677 22.225 20.7014 19.1537C18.443 19.8468 16.8005 16.4328 18.1731 15.5137C19.0194 14.948 20.169 15.5577 20.7681 16.1962C20.8077 16.2383 20.8447 16.2829 20.8788 16.3296C20.8697 14.4763 18.7752 12.5243 19.8368 11.4763C25.4486 5.96011 29.4708 8.33068 30.3019 9.12846C30.6159 10.3281 30.5977 13.4343 30.9192 15.3211C31.585 19.2371 30.2898 21.9656 28.9233 23.2518L28.9248 23.2563ZM20.7757 16.2022H20.7681C20.756 16.1871 20.7529 16.1856 20.7757 16.2022Z",
    fill: "#4676FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9665 19.51C27.9665 19.51 26.4013 19.7481 25.3882 18.6788",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2642 12.9112C28.8708 12.6366 30.0842 12.7595 30.5574 13.034",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7598 13.2307C23.7997 12.7668 24.9671 12.6732 26.0676 12.9653",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7311 14.4279C27.7311 14.4279 27.7099 15.212 28.3969 16.5209C29.0188 17.7069 28.262 18.3015 26.9121 17.9147",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1679 16.5961C19.1679 16.5961 18.6416 18.0855 20.2402 18.2432",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5605 17.2075L18.5327 16.114",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0726 10.4842C31.5852 11.6763 30.7161 14.1076 30.7161 14.1076L30.1898 9.97006C30.1898 9.97006 28.2182 11.4306 24.1777 10.1718C21.1853 9.2375 20.9047 11.5808 21.108 14.0257C21.2081 15.239 21.2005 17.4837 21.2005 17.4837C20.7303 16.0792 19.8233 15.5514 18.88 15.374C18.6631 14.8826 18.5721 14.4776 17.9927 11.9417C17.7379 10.8209 18.4477 9.65762 18.4477 9.65762C18.4477 9.65762 17.9472 8.37906 18.2035 7.50545C19.0468 4.62983 22.7308 5.78251 22.7308 5.78251C22.7308 5.78251 24.0321 3.65916 26.8896 4.04743C29.747 4.4357 30.0609 6.99585 30.0609 6.99585C30.9042 6.76835 32.8274 8.25469 31.0726 10.4842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6112 14.2764C24.8448 14.2764 25.0465 14.5798 25.0662 14.9756C25.0859 15.3715 24.9039 15.696 24.6703 15.7036C24.4368 15.7112 24.2351 15.4003 24.2153 15.0044C24.1956 14.6086 24.3761 14.284 24.6097 14.2764",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3133 14.1332C29.5469 14.1332 29.7501 14.4365 29.7683 14.8339C29.7865 15.2313 29.6061 15.5543 29.3725 15.5619C29.1389 15.5695 28.9372 15.2586 28.9175 14.8612C28.8978 14.4638 29.0783 14.1423 29.3118 14.1332",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5463 10.6664C21.0306 11.4248 20.9988 12.7124 21.108 14.0259C21.2081 15.2392 21.2005 17.4839 21.2005 17.4839C20.7303 16.0794 19.8233 15.5516 18.88 15.3727C18.6631 14.8752 18.5675 14.4778 17.9927 11.9419C17.7379 10.8211 18.4477 9.65783 18.4477 9.65783C18.4477 9.65783 18.4356 9.62749 18.4174 9.57593L21.5463 10.6664Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1482 13.5666L32.1589 14.0928L31.7933 14.1414C31.6349 14.3223 31.5453 14.5532 31.5401 14.7936C31.0851 13.7319 29.4395 13.562 29.4395 13.562L32.1482 13.5666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7646 14.393C28.1317 13.9684 28.8263 13.6848 29.5179 13.6681C30.6509 13.6408 31.573 14.3369 31.5791 15.2242C31.5852 16.1114 30.6691 16.8531 29.5361 16.8804C29.1677 16.9023 28.7998 16.8303 28.4669 16.6711",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2443 13.9123L22.1973 14.4401L22.5598 14.4644C22.6418 14.6821 22.678 14.9145 22.6659 15.1469C23.0269 13.973 24.8954 13.7106 24.8954 13.7106L22.2443 13.9123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8736 13.8301C23.7406 13.8817 22.7654 14.6446 22.6972 15.5349C22.6289 16.4252 23.4904 17.1031 24.6249 17.0516C25.7593 17 26.733 16.2371 26.8028 15.3468C26.8726 14.4565 26.0035 13.7786 24.8736 13.8301Z",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8937 47.3061C18.1441 47.0741 17.3533 47.0064 16.5752 47.1076C15.7971 47.2088 15.05 47.4765 14.3847 47.8925C13.7194 48.3085 13.1515 48.863 12.7199 49.5182C12.2882 50.1735 12.0028 50.914 11.8832 51.6895C11.7635 52.465 11.8124 53.2571 12.0266 54.012C12.2407 54.7669 12.615 55.4667 13.124 56.0639C13.633 56.6611 14.2647 57.1415 14.9761 57.4725C15.6875 57.8035 16.4619 57.9773 17.2465 57.982C17.3178 57.982 17.3876 57.982 17.4589 57.982H17.6955L27.1171 58.349L28.8855 49.1701L18.8937 47.3061Z",
    fill: "#FAAA5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1973 50.195L18.5573 38.1966C19.2153 37.243 19.622 36.1388 19.7396 34.9863C19.8572 33.8337 19.682 32.6701 19.2302 31.6033C18.7784 30.5365 18.0645 29.601 17.1549 28.8835C16.2453 28.166 15.1693 27.6898 14.0265 27.4989C12.8838 27.308 11.7114 27.4086 10.618 27.7915C9.52452 28.1743 8.5454 28.827 7.77136 29.689C6.99731 30.551 6.45339 31.5945 6.19 32.7227C5.92661 33.8509 5.95227 35.0274 6.2646 36.143H6.22365L11.9749 53.9867C12.0158 54.1308 12.0613 54.2734 12.1129 54.4129C12.3716 55.1013 12.7665 55.7304 13.2739 56.2627C13.7814 56.7949 14.391 57.2193 15.0663 57.5105C15.7416 57.8016 16.4687 57.9536 17.2041 57.9572C17.9394 57.9609 18.668 57.8161 19.3461 57.5317C20.0243 57.2472 20.638 56.8288 21.1508 56.3017C21.6635 55.7745 22.0646 55.1493 22.33 54.4635C22.5955 53.7777 22.7199 53.0454 22.6958 52.3104C22.6717 51.5754 22.4996 50.8529 22.1897 50.1859",
    fill: "#FAAA5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9644 47.5048L28.7565 49.3263",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3726 40.0182L21.5353 47.7988",
    stroke: "black",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasculine);
export default __webpack_public_path__ + "static/media/masculine.b76cf03e4929058e770d00a00e6359cf.svg";
export { ForwardRef as ReactComponent };